
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.8.067C.844.067.067.844.067 1.8c0 .956.777 1.733 1.733 1.733.956 0 1.733-.777 1.733-1.733C3.533.844 2.756.067 1.8.067zM1.8 5.267C.844 5.267.067 6.044.067 7c0 .956.777 1.733 1.733 1.733.956 0 1.733-.777 1.733-1.733 0-.956-.777-1.733-1.733-1.733zM1.8 10.467c-.956 0-1.733.777-1.733 1.733 0 .956.777 1.733 1.733 1.733.956 0 1.733-.777 1.733-1.733 0-.956-.777-1.733-1.733-1.733zM7 .067c-.956 0-1.733.777-1.733 1.733 0 .956.777 1.733 1.733 1.733.956 0 1.733-.777 1.733-1.733C8.733.844 7.956.067 7 .067zM7 5.267c-.956 0-1.733.777-1.733 1.733 0 .956.777 1.733 1.733 1.733.956 0 1.733-.777 1.733-1.733 0-.956-.777-1.733-1.733-1.733zM7 10.467c-.956 0-1.733.777-1.733 1.733 0 .956.777 1.733 1.733 1.733.956 0 1.733-.777 1.733-1.733 0-.956-.777-1.733-1.733-1.733zM12.2 3.533c.956 0 1.733-.777 1.733-1.733 0-.956-.777-1.733-1.733-1.733-.956 0-1.733.777-1.733 1.733 0 .956.777 1.733 1.733 1.733zM12.2 5.267c-.956 0-1.733.777-1.733 1.733 0 .956.777 1.733 1.733 1.733.956 0 1.733-.777 1.733-1.733 0-.956-.777-1.733-1.733-1.733zM12.2 10.467c-.956 0-1.733.777-1.733 1.733 0 .956.777 1.733 1.733 1.733.956 0 1.733-.777 1.733-1.733 0-.956-.777-1.733-1.733-1.733z","fill":"currentColor"}})])
          )
        }
      }
    